<template>
  <div class="page">
    <img :src="headImg" v-if="headImg" class="bg" alt="" />

    <div class="content w1200">
      <el-image :src="exData.EpImage" v-if='exData.EpImage' class="logo" fit="contain"></el-image>
      <div class="card">
        <div class="name">{{ exData.EpTitle }}</div>
        <div class="flex">
          <div class="sub_name">展位号：{{ exData.ExtCode }}
          </div>
          <div class="btn" @click="bindCheck(exData.ExtID)">
            查看展商
          </div>
        </div>

        <div class="sub_name2">{{ exData.EpInfo }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { isMobileDevice } from "@/utils/deviceCheck";
export default {
  name: "Details",
  data() {
    return {
      exhid: "",
      EpID: "",
      exData: {},
    };
  },
  created() {
    console.log("调用获取id的方法", this.$route.query);

    if (this.$route.query) {
      this.exhid = this.$route.query.exhid;
      this.EpID = this.$route.query.EpID;
      if (isMobileDevice()) {
        window.location.href = `https://hkh5.eainfor.com/#/pages/index/productDetail?exhid=${this.$route.query.exhid}&EpID=${this.$route.query.EpID}`;
      }
      setTimeout(() => {
        this.fetchData();
        this.getImg()
      }, 0);

    }
  },
  mounted() { },
  methods: {
    getImg() {
      let that = this;
      let url = `/Exh/resourceUrl/${that.exhid}?type=pcbanner`;
      this.$http
        .get(url, {
          headers: {
            "content-type": "application/json",
          },
        })
        .then((res) => {
          console.log("获取图片", res);
          that.headImg = res.data.data;



        })
        .catch((error) => {
          this.$message.error(error);
        });
    },
    bindCheck(ExtID) {
				let that = this;
      
        this.$router.push({
        path: `/Details?exhid=${that.exhid}&ExtID=${ExtID}`,
      });
			},
    fetchData() {
      let that = this;
      let url = `/Exh/extProductDetail/${that.exhid}?EpID=${that.EpID}`;
      this.$http
        .get(url, {
          headers: {
            "content-type": "application/json",
          },
        })
        .then((res) => {
          console.log("获取列表", res);
          this.exData = res.data.data;
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },
  },
};
</script>
<style lang="less" scoped>
.page {
  background: #f6f6f6;
  position: absolute;
  width: 100%;
  min-height: 100%;
}

.bg {
  display: block;
  width: 100%;
}

.logo {
  width: 442px;
  height: 340px;
  background: #ffffff;
  border-radius: 7px;
  margin-top: 72px;
}

.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.card {
  padding-bottom: 80px;

  .name {
    font-weight: 500;
    font-size: 24px;
    color: #333333;
    line-height: 24px;
    white-space: nowrap;
    overflow: hidden;
    margin-top: 33px;
    text-overflow: ellipsis;
  }

  .sub_name {
    font-weight: 400;
    font-size: 19px;
    color: #333333;
    line-height: 24px;
    background: #e7f4fe;
    padding: 5px 10px;
    display: inline-block;
    margin: 14px 0 4px 0;



  }

  .btn {
    // width: 150px;
    // height: 24px;
    background: #218CDF;
    border-radius: 5px;
    text-align: center;
    line-height: 24px;
    font-weight: 400;
    padding: 5px 10px;
    font-size: 20px;
    color: #FFFFFF;
    margin-left: 30px;
    cursor: pointer;
  }

  .sub_name2 {
    font-weight: 400;
    font-size: 18px;
    color: #999;
    line-height: 33px;
    white-space: pre-wrap;
  }
}
</style>
